import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { mergeDeepLeft } from "ramda";
import { IAppState } from "./types";
import clearStore from './clearStore';

import createAuthSlice from "./slices/auth";
import createLoadingSlice from "./slices/loading";
import createStatsSlice from "./slices/stats";

const useStore = create<IAppState>()(
    devtools(
        persist(immer(
            (...a) => ({
                ...createAuthSlice(...a),
                ...createLoadingSlice(...a),
                ...clearStore(...a),
                ...createStatsSlice(...a)
            })
        ), {
            name: 'duul-backoffice',
            // storage: () => createJSONStorage(() => localStorage),
            merge: (persistedState: any, currentState) =>
                mergeDeepLeft(persistedState, currentState)
        })
    )
);

export default useStore;